<template>
  <div id="chatwindow">
    <div class="row chatHeader">
      <div :class="ls1180 ? 'col-6' : 'col-4'">
        <div class="row">
          <div :class="[smw ? 'madjust' : '', 'col-2', 'noPaddingsLR']">
            <b-avatar :size="smw ? 33 : 44" class="avatarka" :src="clientPhotoURL"></b-avatar>
          </div>
          <div
            class="col-9 noPaddingsLR"
            :style="room.clientEndpoint == 'sms' ? 'padding-top:5px;' : 'padding-top:10px;'"
          >
            <p
              class="avatarHeaderName"
            >{{room.userId == '' ? 'UnIdentified user' : room.user_firstName + ' ' + room.user_lastName}}</p>
            <p
              class="avatarHeaderAdd"
              v-if="room.clientEndpoint == 'sms' && room.userphone"
            >(SMS {{room.userphone}})</p>
          </div>
        </div>
      </div>

      <div :class="[ls1180 ? 'col-6' : 'col-8', 'endConvers']">
        <div class="row" style="justify-content:flex-end">
          <div class="col headctrlbtn">
            <b-button
              v-b-modal.modalViewOldChat
              size="sm"
              variant="outline-primary"
              class="endConv h2 mb-2"
            >{{ls1180 ? 'History' : 'View history'}}</b-button>
          </div>
          <div class="col headctrlbtn" v-if="isMyChat">
            <b-button
              class="endConv h2 mb-2"
              v-b-modal.modal-toggleUser
              variant="outline-primary"
              size="sm"
            >Switch{{ls1180 ? '' : ' chat to'}}</b-button>
          </div>

          <div class="col headctrlbtn" v-if="isMyChat">
            <b-button
              class="endConv h2 mb-2"
              @click="$emit('switchChatTo', {ssId: room.ssId, adminId: room.clientEndpoint == 'sms' ? 'smsFinished' : 'bot'})"
              variant="danger"
              size="sm"
            >End{{ls1180 ? '' : ' conversation'}}</b-button>
          </div>
        </div>
      </div>
    </div>
    <hr class="style-two" />
    <!-- v-bind:style="{ height: windowHeight-199 + 'px' }" -->
    <div
      class="chat-box"
      id="chatScroll"
      v-chat-scroll
      v-bind:style="{ height: windowHeight-170 + 'px' }"
    >
      <ChatWindow :msgs="msgs" :isMain="true" />
    </div>
    <footer class="sticky-footer" v-if="isMyChat">
      <b-form
        @submit.prevent=" $emit('sendMessage', {msg: inputMessage, room: room}); inputMessage = ''"
      >
        <!-- ssId: room.ssId, clientEndpoint: room.clientEndpoint, userfbId: room.userfbId, phone: room.userphone -->
        <b-input-group>
          <b-form-input
            class="inputMessage"
            id="message"
            v-model.trim="inputMessage"
            placeholder="Enter your message"
          ></b-form-input>
          <b-button
            class="sendMessBtn"
            aria-pressed="true"
            type="submit"
            variant="primary"
            :disabled="!inputMessage"
          >
            <b-icon icon="cursor"></b-icon>
          </b-button>
        </b-input-group>
      </b-form>
    </footer>
    <footer
      class="sticky-footer"
      v-if="!admins.find(el => el.adminId == room.adminId) && !isMyChat"
    >
      <b-button
        class="blockInputBtn"
        @click="$emit('blockNote', room.ssId); $emit('switchChatTo', {ssId: room.ssId, adminId: maId});"
        variant="outline-primary"
      >Take over the conversation</b-button>
    </footer>

    <!-- MODALS -->
    <!-- HISTORY MSGS MODAL -->
    <b-modal
      size="xl"
      header-class="headerModalClass"
      id="modalViewOldChat"
      centered
      hide-footer
      :title="room.userId == '' ? 'UnIdentified user' : room.user_firstName + ' ' + room.user_lastName"
    >
      <viewChatWindow :userId="room.userId" mode="userId" :colId="room.ssId" />
    </b-modal>
    <!-- HISTORY MSGS MODAL END-->

    <!-- Switch User MODAL -->
    <b-modal
      id="modal-toggleUser"
      title="Switch representative"
      @ok="selectedAdmin ? $emit('switchChatTo', {ssId: room.ssId, adminId: selectedAdmin}) : ''"
      centered
    >
      <div>
        <div
          class="mt-3"
        >{{AdminsList().length > 0 ? 'You are about to route this conversation to:' : "Looks like there's nobody else online"}}</div>
        <b-form-select v-model="selectedAdmin" :options="AdminsList()" size="sm" class="mt-3"></b-form-select>
      </div>
    </b-modal>
    <!-- Switch User MODAL END-->

    <!-- MODALS End-->
  </div>
</template>

<script>
import ChatWindow from "./../additionalComponents/ChatWindow.vue";
import viewChatWindow from "./../additionalComponents/viewChatWindow.vue";

export default {
  name: "MainChatWindow",
  components: {
    ChatWindow,
    viewChatWindow
  },
  props: {
    roomstatus: String,
    room: Object,
    msgs: Array,
    selected: Boolean,
    admins: Array,
    windowHeight: Number,
    windowWidth: Number,
    maId: String
  },
  data() {
    return {
      clientPhotoURL:
        "https://firebasestorage.googleapis.com/v0/b/car-appointment-fsqahl.appspot.com/o/roomadmin_pictures%2Favatar_pict.png?alt=media&token=67728320-df0d-4f9c-a63b-a7340b4fd3fb",
      userPhotoURL: "",
      inputMessage: "",
      selectedAdmin: "",
      // isRoomWatched: false,
      statusOptions: {
        online: "success",
        away: "warning",
        facebook: "primary"
      }
    };
  },
  computed: {
    ls1180() {
      return this.windowWidth <= 1180;
    },
    smw() {
      return this.windowWidth < 1240;
    },
    isMyChat() {
      return this.room.adminId == this.maId;
    }
  },

  watch: {},

  mounted() {},

  methods: {
    AdminsList() {
      let arr = [];
      for (let i in this.admins) {
        arr.push({
          value: this.admins[i].adminId,
          text: `${this.admins[i].name} (${this.admins[i].adminEmail})`
        });
      }
      return arr;
    },

    suggestionsShowRows(arr) {
      let len = 4;
      var chunks = [],
        i = 0,
        n = arr.length;
      while (i < n) {
        chunks.push(arr.slice(i, (i += len)));
      }

      return chunks;
    },
    preventDef(evt) {
      evt.preventDefault();
    }
  }
};
</script>
<style>
.chatHeader {
  background-color: #ffffff;
  height: 64px;
  padding: 10px;
}
.avatarHeaderName {
  margin-bottom: 0;
  /* display: inline;
  background-color: rgba(255, 255, 255, 0); */
}
.avatarHeaderAdd {
  font-size: 11px;
}
.madjust {
  margin-top: 6px;
  margin-right: 4px;
}
.avatarka {
  background-color: rgba(255, 255, 255, 0);
}
.noPaddingsLR {
  padding-left: 0px;
  padding-right: 0px;
  text-align: left;
  display: inline;
}
.endConvers {
  display: inline;
  text-align: right;
}
.endConv {
  cursor: pointer;
  margin-bottom: 0px;
  margin-top: 10px;
}
hr.style-two {
  border: 0;
  height: 1px;
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.445),
    rgba(0, 0, 0, 0)
  );
  margin-top: 0px;
  margin-bottom: 0px;
}
.chat-box {
  /* padding-bottom: 70px; */
  width: 100%;
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  /* resize: vertical; */
  background-color: #ffffff;
}
#chatScroll::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.3); */
  background-color: #ffffff;
}

#chatScroll::-webkit-scrollbar {
  width: 8px;
  background-color: #ffffff;
}

#chatScroll::-webkit-scrollbar-thumb {
  background-color: rgb(187, 187, 187);
}

.inputMessage {
  border: 0;
}
footer.sticky-footer {
  /* .sticky-footer { */
  /* max-width: 50%;  */
  /* position: fixed; */
  position: absolute;
  bottom: 0;
  /* left: 17%; */
  width: 100%;
  padding-bottom: 6px;
  background-color: #ffffff;
  border-top: solid 1px #efefef;
}

.blockInputBtn {
  width: 100%;
  text-align: center;
  color: #266db3;
  border-color: #266db3;
  border-radius: 0;
  /* font-size: 42px; */
}

.blockInputBtn:hover {
  color: white;
  background-color: #266db3;
  border-color: #266db3;
}
#chatwindow .row {
  margin-left: 0;
  margin-right: 0;
}
.headerModalClass .modal-title {
  font-weight: bold;
  color: rgb(3, 0, 153);
}
.headctrlbtn {
  max-width: fit-content;
}
@media (max-width: 1180px) {
  .headctrlbtn {
    max-width: fit-content;
    padding-left: 7px;
    padding-right: 7px;
  }
}
</style>